export enum ROUTES {
  HOME = '/',
  SKILLS = '/skills',
  PROJECTS = '/projects',
  EDUCATION = '/education',
  CONTACTME = '/contactMe',
}
